<template>
  <div class="p-0">
    <h1>Panel administracyjny</h1>
    <div class="linkBlocks">
      <button
        type="button "
        class="btn btn-lg link sideButton userName"
        @click="copyToClipboard"
      >
        <div class="d-flex flex-row align-items-center" v-if="selectedUser">
          <img src="../icons/phone.svg" /> {{ selectedUser.phone }}
        </div>
      </button>

      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/users/id/' + this.selectedUser.id,
        }"
      >
        <a href="#" class="linkButton">
          <button type="button " class="btn btn-lg link sideButton">
            <div class="d-flex flex-row align-items-center">
              <img src="../icons/profile.svg" />
              <span>Profil użytkownika</span>
            </div>
          </button>
        </a>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/senior/id/' + this.selectedUser.id,
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/profile.svg" />
            <span>Profil Seniora</span>
          </div>
        </button>
      </router-link>

      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/customer/' + this.selectedUser.id + '/orders',
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/reports.svg" />
            <span>Zgłoszenia Seniora</span>
          </div>
        </button>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/customer/' + this.selectedUser.id + '/orders-crs',
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/reports.svg" />
            <span>Zgłoszenia CRS</span>
          </div>
        </button>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/customer/' + this.selectedUser.id + '/subscriptions',
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/reports.svg" />
            <span>Subskrypcje</span>
          </div>
        </button>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/customer/' + this.selectedUser.id + '/obiady',
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/obiadyIcon.svg" />
            <span>Obiady</span>
          </div>
        </button>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/employee/id/' + this.selectedUser.id,
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/profile.svg" />
            <span>Profil Opiekuna</span>
          </div>
        </button>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/employee/' + this.selectedUser.id + '/orders',
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/topAndDownArrows.svg" />
            <span>Zlecenia Opiekuna</span>
          </div>
        </button>
      </router-link>

      <!-- <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/employee/' + this.selectedUser.id + '/user-services',
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/light.svg" />
            <span>Usługi Opiekuna</span>
          </div>
        </button>
      </router-link> -->

      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          name: 'PaymentsList',
          query: { search: this.selectedUser.phone },
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/payments.svg" />
            <span>Płatności</span>
          </div>
        </button>
      </router-link>

      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{ path: '../../chat/' + this.selectedUser.id }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/messages.svg" />
            <span>Wiadomości</span>
          </div>
        </button>
      </router-link>
      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/notes/' + this.selectedUser.id,
          query: { id: this.selectedUser.phone },
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/notes.svg" />
            <span>Notatki</span>
          </div>
        </button>
      </router-link>

      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/sms/' + this.selectedUser.id,
          query: { id: this.selectedUser.phone },
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/sms.svg" />
            <span>Smsy</span>
          </div>
        </button>
      </router-link>

      <router-link
        class="sideButton"
        v-if="this.selectedUser"
        :to="{
          path: '/promotions/' + this.selectedUser.id,
          query: { id: this.selectedUser.phone },
        }"
      >
        <button type="button" class="btn mr-3 btn-lg link sideButton">
          <div class="d-flex flex-row align-items-center">
            <img src="../icons/promotions.svg" />
            <span>Promocje</span>
          </div>
        </button>
      </router-link>
      <!-- <button
        @click="clearSelectedUser"
        class="btn btn-danger btn-sm closeUserPanel"
      >
        Zamknij
      </button> -->
      <button
        @click="clearSelectedUser"
        type="button"
        class="btn mr-3 btn-lg link sideButton"
      >
        <div class="d-flex flex-row align-items-center">
          <img src="../icons/hidden.svg" />
          <span>Ukryj Panel</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    clearSelectedUser() {
      this.$store.dispatch("setUserToNull");
    },

    copyToClipboard() {
      const el = document.createElement("textarea");
      el.value = this.selectedUser.phone;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
  },
  computed: {
    selectedUser() {
      return this.$store.getters.getSelectedUser;
    },
    searchError() {
      return this.$store.getters.getSelectedUserError;
    },
  },
};
</script>

<style scoped>
.userName {
  font-size: 13px;
  color: rgb(70, 69, 69);
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px !important;
}
.linkBlocks {
  color: #090741;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-items: center;
  position: relative;
  padding: 40px 0 40px 0 !important;
  font-family: "Poppins", sans-serif;
  background: #fff;
  border-radius: 10px;
}
.leftBar i {
  margin-right: 5px !important;
}

button:focus {
  box-shadow: none;
}
button:active,
button:visited,
button:focus {
  background: #f2f2f2 !important;
}
.link {
  font-size: 11px;
  margin-top: 5px;
}
.closeUserPanel {
  margin-top: 30px;
}
.sideButton {
  width: 100%;
  margin: 0 !important;
  margin-bottom: 3px;
  border-radius: 9px;
  font-size: 14px;
  padding: 5px;
}
.sideButton img {
  width: 18px;
  margin-right: 20px;
}
@media only screen and (max-width: 1749px) {
  .link {
    font-size: 13px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1632px) {
  .link {
    font-size: 13px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1515px) {
  .link {
    font-size: 13px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1366px) {
  .link {
    font-size: 12px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1338px) {
  .link {
    font-size: 11px;
    margin-top: 5px;
  }
}
.linkButton:visited {
  background: red;
}
</style>
